import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class LeakAccountAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'leakaccount';

	getReportSource() {
		let request = {
			url: [this.getAPIUrl(), 'report/source'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new LeakAccountAPI();
